import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LegalPrivacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-900">LotusRecruiter</Link>
          <Link to="/login" className="text-sm text-lotus-gold font-semibold">
            {t('legal.customerLogin')}
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-md p-8 space-y-8">
          <div>
            <p className="text-sm uppercase tracking-widest text-gray-400 font-semibold">{t('legal.privacy.label')}</p>
            <h1 className="text-3xl font-bold text-gray-900 mt-2">{t('legal.privacy.title')}</h1>
            <p className="mt-4 text-gray-600 leading-relaxed">
              {t(
                'legal.privacy.intro')}
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.dataControllerTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.privacy.dataControllerText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.dataCollected')}</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>{t('legal.privacy.data1')}</li>
              <li>{t('legal.privacy.data2')}</li>
              <li>{t('legal.privacy.data3')}</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.purposeTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t(
                'legal.privacy.purpose')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.transferTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.privacy.transferText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.retentionTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.privacy.retentionText')}
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-2 text-sm text-gray-700">
              <p className="font-medium text-gray-900">{t('legal.privacy.retentionDetails')}</p>
              <ul className="list-disc list-inside space-y-1">
                <li>{t('legal.privacy.retentionDetail1')}</li>
                <li>{t('legal.privacy.retentionDetail2')}</li>
                <li>{t('legal.privacy.retentionDetail3')}</li>
                <li>{t('legal.privacy.retentionDetail4')}</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.withdrawalTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.privacy.withdrawalText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.dataPortabilityTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.privacy.dataPortabilityText')}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.privacy.rightsTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('legal.privacy.rightsTextPrefix')}
              <Link to="/legal/kvkk-aydinlatma" className="text-lotus-gold underline hover:text-lotus-gold/80">
                {t('legal.privacy.kvkkLinkText')}
              </Link>
              {t('legal.privacy.rightsTextSuffix')}
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.contact')}</h2>
            <p className="text-gray-600">info@aiotech.tr</p>
            <p className="text-gray-600">+90 533 614 67 74</p>
            <p className="text-gray-600">Merkez Mah. 52072 Sk. No:7 İç Kapı No:10 Mezitli/Mersin</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default LegalPrivacy;
